import React from 'react';
import PaginationArrowLeftIcon from '../icons/PaginationArrowLeftIcon';
import PaginationArrowRightIcon from '../icons/PaginationArrowRightIcon';

function Pagination({ currentPage, itemsPerPage, totalItems, onPageChange, prevText = "Anterior", nextText = "Siguiente" }) {
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    return (
        <nav aria-label="Page navigation">
            <ul className="pagination justify-content-start">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button
                        className="page-link"
                        onClick={() => onPageChange(currentPage - 1)}
                        aria-label={prevText}
                    >
                        <PaginationArrowLeftIcon />
                    </button>
                </li>
                {/* Create page number links */}
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                        <button className="page-link" onClick={() => onPageChange(page)}>
                            {page}
                        </button>
                    </li>
                ))}
                {/* Create next page link */}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button
                        className="page-link"
                        onClick={() => onPageChange(currentPage + 1)}
                        aria-label={nextText}
                    >
                        <PaginationArrowRightIcon />
                    </button>
                </li>
            </ul>
        </nav>
    );
}

export default Pagination;